import {Nodes} from 'common/src/modules/nodes/nodes.types';

export default function wouldCreateLoop(
  sourceId: number,
  targetId: number,
  existingNodes: Nodes,
): boolean {
  // If source and target are the same, it's a self-loop
  if (sourceId === targetId) {
    return true;
  }

  // Build adjacency list from existing connections
  const adjacencyList = new Map<number, Set<number>>();

  Object.values(existingNodes).forEach((node) => {
    if (node.outputs) {
      node.outputs.forEach((output) => {
        if (output.nodeId && output.nodeId !== 0) {
          if (!adjacencyList.has(node.id)) {
            adjacencyList.set(node.id, new Set());
          }

          const nodeConnections = adjacencyList.get(node.id);

          if (nodeConnections) {
            nodeConnections.add(output.nodeId);
          }
        }
      });
    }
  });

  // Add the proposed connection temporarily
  if (!adjacencyList.has(sourceId)) {
    adjacencyList.set(sourceId, new Set());
  }

  // Check if we can reach sourceId from targetId (which would create a cycle)
  const visited = new Set<number>();
  const recursionStack = new Set<number>();

  function hasCycle(nodeId: number): boolean {
    if (recursionStack.has(nodeId)) {
      return true;
    }

    if (visited.has(nodeId)) {
      return false;
    }

    visited.add(nodeId);
    recursionStack.add(nodeId);

    const neighbors = adjacencyList.get(nodeId);

    if (neighbors) {
      for (const neighbor of neighbors) {
        if (hasCycle(neighbor)) {
          return true;
        }
      }
    }

    recursionStack.delete(nodeId);

    return false;
  }

  return hasCycle(targetId);
}
